import type { StorefrontMood, StorefrontMoodRecommendation } from './moods';

export function MoodSuggestion({
  mood,
  recommendations: _recommendations,
  loading: _loading = false,
  error: _error = false,
}: {
  mood: StorefrontMood;
  recommendations: StorefrontMoodRecommendation[];
  loading?: boolean;
  error?: boolean;
}) {
  return (
    <div className="mood-suggestion" aria-live="polite">
      <strong>Gợi ý dành cho bạn</strong>
      <p>{mood.message}</p>
    </div>
  );
}
